import React, { useState } from 'react'
import { useAuth } from '@polvo-labs/react-auth'
import Button from '../../../components/Button'
import Modal from '../../../components/Modal'
import Text from '../../../components/Text'
import DisableForm from '../../../forms/Disable'
import { ModalContent } from './styles'
import Icon from '../../../components/Icon'

interface Props {

}

const Disable: React.FC<Props> = () => {
  const { logout } = useAuth()
  const [open, setOpen] = useState(false)
  const [submitted, setSubmitted] = useState(false)

  return (
    <>
      <div
        id="disable-container"
        style={{ marginTop: '14px' }}
        onClick={() => setOpen(true)}
      >
        <Button
          style={{ float: 'left', paddingLeft: '0px' }}
          before={(
            <svg
              width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M7 7L10 10M10 10L13 13M10 10L13 7M10 10L7 13M19 10C19 14.9706 14.9706 19 10 19C5.02944 19 1 14.9706 1 10C1 5.02944 5.02944 1 10 1C14.9706 1 19 5.02944 19 10Z"
                stroke="#868686"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          )}
          label="Desativar conta"
          backgroundColor="transparent"
          fontColor="darkGray"

        />
        <Button
          style={{ float: 'right' }}
          after={(
            <Icon
              name="arrow"
            />
          )}
          label=""
          backgroundColor="transparent"
          fontColor="darkGray"
        />

      </div>

      <Modal
        open={open}
        small
        onToggle={open => setOpen(open)}
      >
        <ModalContent>
          <Text
            tag="h2"
            align="center"
          >
            DESEJA DESATIVAR A SUA CONTA?
          </Text>
          <Text
            tag="p"
          >
            Digite sua senha para desativar a conta.
          </Text>
          <Text
            tag="p"
          >
            Sua conta poderá ser reativada, caso você acesse com login e senha nos próximos 30 dias. Não
            havendo acesso neste prazo, a conta é excluída.
          </Text>

          {!submitted ? (
            <DisableForm
              onSubmit={() => {
                setSubmitted(true)
                setTimeout(() => {
                  logout!()
                }, 5000)
              }}
            />
          ) : (
            <p>Conta desativada com sucesso.</p>
          )}
        </ModalContent>
      </Modal>
    </>
  )
}

export default Disable
